import { useEffect } from 'react';
import { toast } from 'react-toastify';

import { setPermissionDeniedHandler } from '@/core/api';

/**
 * The app half of the global 403 handler (backend ADR-029).
 *
 * `core/api/client.ts` recognises a refused **write** on every request and
 * calls one registered handler; this component IS that handler — the same
 * split as the 402 seam (FE-ADR-021), for the same reason: the client must not
 * import UI, and no feature should be recognising 403 on its own mutations.
 * Features keep their own failure paths for everything else and call
 * `toastApiError`, which stays silent once this seam has spoken.
 *
 * It renders the server's own message verbatim. The backend localizes its
 * refusals (the client sends `Accept-Language`) and they already name the way
 * out — "Duplicate the test to make it yours" — so inventing a client-side
 * sentence here would replace a specific instruction with a generic one.
 *
 * Reads are untouched: the client only routes unsafe methods here, because a
 * 403 on a GET is a screen that explains itself.
 */
export function PermissionDeniedHandler() {
  useEffect(() => {
    setPermissionDeniedHandler(error => toast.error(error.message));
    return () => setPermissionDeniedHandler(() => {});
  }, []);

  return null;
}
